import { CdkMenu, CdkMenuTrigger } from '@angular/cdk/menu';
import { Component, Input, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Approval } from 'src/app/models/document';

@Component({
  selector: 'app-document-approval',
  templateUrl: './document-approval.component.html',
  styleUrls: ['./document-approval.component.scss']
})
export class DocumentApprovalComponent {
  @Input() approval?: {
    status: Approval;
    user?: {
      ref: string;
      firstName: string;
      lastName: string;
      avatar: string;
    };
  }
  @ViewChild('menu') menu?: CdkMenu;

  // mouseEnter() {
  //   console.log("mouse enter", this.menu)
  //   if (this.menuTrigger)
  //     this.menuTrigger.openMenu();
  // }

  // mouseLeave() {
  //   console.log("mouse leave")
  //   if (this.menuTrigger)
  //     this.menuTrigger.closeMenu();
  // }
}
